import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Navbar, OIDC, cookie } from '@devportal/common';
import { login, logout } from 'utils';

function WithNavLayout({ children }: any) {
  const { pathname } = useLocation();
  const accessToken = cookie.get('accessToken');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    const childResponse = (event) => {
      if (event?.data?.redirectPath) {
        const sanitizedRedirectPath = encodeURI(event.data.redirectPath);
        const currentDomain = window.location.origin;
        const redirectDomain = new URL(sanitizedRedirectPath).origin;

        if (currentDomain === redirectDomain) {
          window.location.replace(sanitizedRedirectPath);
        } else {
          console.log('Redirecting to external domain is not allowed.');
        }
      }
    };
    window.addEventListener('message', childResponse);
    return () => window.removeEventListener('message', childResponse);
  }, []);

  const logInOutHandler = async () => {
    if (accessToken?.length) {
      await logout();
    } else {
      await login(window.location.href);
    }
  };

  return (
    <div>
      <div className="bg-white w-full fixed top-0 z-[200]">
        <Navbar isloggedIn={!!accessToken?.length} onLogInOutClick={logInOutHandler} />
      </div>

      <div className="mt-[104px]">{children}</div>
    </div>
  );
}

export { WithNavLayout };
